<div fxLayout="row" fxLayoutAlign="space-between start" class="header m-b-32">
  <div class="popup-title" fxFlex>CURRICULUM LIMITED - TERMS OF USE</div>
  <curr-icon-button icon="close" (click)="dialogRef.close()"></curr-icon-button>
</div>

<div class="full-width popup-content hidden-y-scroll">
  <curr-terms-of-use-content></curr-terms-of-use-content>
</div>

